// extracted by mini-css-extract-plugin
module.exports = {"positionedBox":"ProblemDefinition_positionedBox__IMCEU","wrapper":"ProblemDefinition_wrapper__2bAVo","text":"ProblemDefinition_text__2CnAm"};